import { covers } from '@/mocks/home';

export default function CoverWall() {
  const [feature, ...rest] = covers;

  return (
    <section id="covers" className="border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="flex items-center gap-2">
          <span className="h-5 w-1 rounded-full bg-primary-500" />
          <span className="font-label text-sm tracking-[0.2em] text-primary-700">COVER STORIES</span>
        </div>
        <div className="mt-3 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">封面专题</h2>
          <p className="text-sm text-foreground-600">把入口、排查与收藏整理成专题封面，一眼看懂重点。</p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-12">
          <article className="group relative overflow-hidden rounded-lg lg:col-span-6">
            <div className="relative h-72 w-full lg:h-[520px]">
              <img
                src={feature.image}
                alt={feature.title}
                title={`${feature.title} - 51黑料入口`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
              <span className="inline-flex rounded-full bg-primary-500 px-3 py-1 font-label text-[13px] tracking-wider text-foreground-950">
                {feature.tag}
              </span>
              <h3 className="mt-3 font-heading text-xl leading-snug text-background-50 md:text-2xl">{feature.title}</h3>
              <p className="mt-2 text-[13px] text-background-200">{feature.subtitle}</p>
            </div>
          </article>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-6 lg:grid-cols-2">
            {rest.map((c) => (
              <article key={c.id} className="group overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="relative h-48 w-full overflow-hidden sm:h-56">
                  <img
                    src={c.image}
                    alt={c.title}
                    title={`${c.title} - 51黑料地址`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[12px] text-foreground-800">
                    {c.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base leading-snug text-foreground-950 md:text-lg">{c.title}</h3>
                  <p className="mt-2 text-[13px] text-foreground-600">{c.subtitle}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}